<template lang="html">
  <svg
    :width="width"
    :height="height"
    :fill="color"
    viewBox="0 0 27.696 31.389"
  ><defs></defs><g transform="translate(0 0)"><g transform="translate(-5 -3)"><path d="M25,27H13.923a.923.923,0,0,0,0,1.846H25A.923.923,0,0,0,25,27Z" transform="translate(-0.614 -1.843)"/><path d="M17.507,22.493a.923.923,0,0,0,1.228,0l6.758-6.019A.923.923,0,1,0,24.265,15.1l-6.139,5.428-3.444-3.065a.925.925,0,0,0-1.228,1.385Z" transform="translate(-0.625 -0.908)"/><path d="M28.856,4.93A2.77,2.77,0,0,0,26.234,3H11.462A2.77,2.77,0,0,0,8.841,4.93,4.616,4.616,0,0,0,5,9.462V29.773a4.616,4.616,0,0,0,4.616,4.616H22.541a.923.923,0,0,0,0-1.846H9.616a2.77,2.77,0,0,1-2.77-2.77V9.462A2.77,2.77,0,0,1,8.9,6.8a2.77,2.77,0,0,0,2.567,1.736.923.923,0,1,0,0-1.846.923.923,0,0,1,0-1.846H26.234a.923.923,0,1,1,0,1.846H15.155a.923.923,0,0,0,0,1.846H26.234A2.77,2.77,0,0,0,28.8,6.8a2.77,2.77,0,0,1,2.05,2.659V29.773a2.77,2.77,0,0,1-2.77,2.77.923.923,0,0,0,0,1.846A4.616,4.616,0,0,0,32.7,29.773V9.462A4.616,4.616,0,0,0,28.856,4.93Z" transform="translate(0 0)"/></g></g></svg>
</template>

<script>
  import mixinIcons from '../mixins/mixin-icons.js'

  export default {
    mixins: [
      mixinIcons
    ]
  };
</script>

<style lang="css" scoped>

</style>



// WEBPACK FOOTER //
// src/components/icons/BookacoachIcon.vue